import { Component, forwardRef, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'vnm-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true
    }
  ]
})
export class ColorPickerComponent implements ControlValueAccessor {
  @HostBinding('class.p-inputgroup') uiInputGroup = true;

  @Input() value = '#000000';
  oldValue: string;

  inputBlur(_event: Event) {
    if (this.value.length !== 7) {
      this.value = this.oldValue;
    }
  }

  inputFocus(_event: Event) {
    this.oldValue = this.value;
  }

  inputReset(event: Event) {
    const input = event.currentTarget as HTMLInputElement;
    input.blur();
  }

  onChange = (_value: string) => {};
  onTouched = () => {};

  writeValue(value: string) {
    this.value = value || '';
    this.onChange(this.value);
  }

  registerOnChange(fn: (value: string) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(_: UntypedFormControl) {
    return null;
  }
}
